import $ from 'jquery';

const $window = $(window);

/*
 *リンク別窓
 */
$('#wellithOlive a').attr('target', '_blank');


/*
 *右カラムの固定表示
 */
let wrap = document.getElementById("wrap");
let primary = document.getElementById("primary");
let secondary = document.getElementById("secondary");
$(secondary).wrap('<div id="stickyWrapper">');
let $stickyWrapper = $('#stickyWrapper');

function stickySecondary() {
  let _wBcr = wrap.getBoundingClientRect();
  let _pBcr = primary.getBoundingClientRect();
  let _sBcr = secondary.getBoundingClientRect();

  let _wHeight = (typeof window.innerHeight != 'undefined') ? Math.max(window.innerHeight, $window.height()) : $window.height();
  
  /*
   *左カラムが右カラムより右にある時
   */
  if(_pBcr.left >= _sBcr.left) {
    $stickyWrapper.removeClass("sticky");
    $stickyWrapper.removeClass("bottom");
    return;
  }
  
  /*
   *右カラムが左カラムより長い時
   */
  if(_pBcr.height <= _sBcr.height) {
    $stickyWrapper.removeClass("sticky");
    $stickyWrapper.removeClass("bottom");
    return;
  }
  
  if (_wBcr.top < 0) {
    let mtx = Math.round(_wBcr.height - _sBcr.height);
    let tx = Math.min(Math.round(_wBcr.top * -1), mtx);
    
    $stickyWrapper.addClass("sticky");
    if(mtx <= tx) {
      $stickyWrapper.addClass("bottom");
    } else {
      $stickyWrapper.removeClass("bottom");
    }
    
  } else {
    $stickyWrapper.removeClass("sticky");
    $stickyWrapper.removeClass("bottom");
  }
}
$window.on('resize, scroll', function () {
  stickySecondary();
});


/*
 *スライダーギャラリー
 *ショートコードで、sliderを1以上にするとスライダーギャラリーに。
 *[gallery slider="1" size="large" link="none" columns="1" ids="80,79,78"]
 */
import 'slick-carousel';

$('.gallery.slider').each(function (i, e) {
  let $e = $(e);
  var slidesToShow = $e.data('slider');
  $(e).slick({
    arrows: true,
    dots: true,
    slidesToShow: slidesToShow
  });
});



// WEBPACK FOOTER //
// ./js/main.js